// extracted by mini-css-extract-plugin
export default {"dynamic__delete__button":"addStandardModal_dynamic__delete__button__uMlPI"};